<template>
  <div class="vipLink">
    <div class="vipLink-banner">
      <img :src="img.wdBg" alt />
      <div class="vipLink-box" v-if="userObj.isExpire === 1">
        <div class="title">会员申请</div>
        <div class="text">开通会员享受全部微刊阅读</div>
      </div>
      <div class="vipLink-box loging" v-else>
        <div class="img">
          <img :src="userObj.head" alt />
        </div>
        <div class="name">
          <p>{{ userObj.name }}</p>
          <p class="time">{{ userObj.expirationDate | timeData }} 到期</p>
        </div>
      </div>
    </div>
    <div v-if="userObj.isExpire === 1">
      <div class="vip-nav">
        <span
          :class="{ act: typeItem === 1 || typeItem === 3 }"
          @click="tabType(1)"
          >个人会员</span
        >
        <span :class="{ act: typeItem === 2 }" @click="tabType(2)"
          >单位会员</span
        >
      </div>
      <div class="vip" v-if="typeItem === 1">
        <el-form
          :model="ndividualObj"
          ref="ndividualObjForm"
          label-width="0px"
          class="demo-ruleForm"
          :rules="ndividualRules"
        >
          <div class="vip-title">会员资料填写</div>
          <div class="vip-name">会员昵称</div>
          <div class="vip-input">
            <el-form-item prop="username">
              <el-input
                v-model="ndividualObj.username"
                placeholder="请输入会员昵称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">真实姓名</div>
          <div class="vip-input">
            <el-form-item prop="name">
              <el-input
                v-model="ndividualObj.name"
                placeholder="请输入真实姓名"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">手机号码</div>
          <div class="vip-input">
            <el-form-item prop="mobile">
              <el-input
                v-model="ndividualObj.mobile"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">性别</div>
          <div class="vip-input">
            <el-form-item>
              <!-- <el-input
                v-model="ndividualObj.sex"
                placeholder="请输入手机号码"
              ></el-input>-->
              <el-select v-model="ndividualObj.sex">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="vip-name">民族</div>
          <div class="vip-input">
            <el-form-item prop="nation">
              <el-input
                v-model="ndividualObj.nation"
                placeholder="请输入民族"
              ></el-input>
            </el-form-item>
          </div>
          <!-- <div class="vip-name">出生年月</div>
          <div class="vip-input">
            <el-form-item prop="birth">
              <el-input
                v-model="ndividualObj.birth"
                placeholder="请输入出生年月，如2020-01-01"
              ></el-input>
            </el-form-item>
          </div> -->
          <div class="vip-name">身份证</div>
          <div class="vip-input">
            <el-form-item prop="idcard">
              <el-input
                v-model="ndividualObj.idcard"
                placeholder="请输入身份证"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">邮箱</div>
          <div class="vip-input">
            <el-form-item prop="email">
              <el-input
                v-model="ndividualObj.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">专业</div>
          <div class="vip-input">
            <el-form-item prop="major">
              <el-input
                v-model="ndividualObj.major"
                placeholder="请输入专业"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">学历</div>
          <div class="vip-input">
            <el-form-item prop="education">
              <el-input
                v-model="ndividualObj.education"
                placeholder="请输入学历"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">工作单位</div>
          <div class="vip-input">
            <el-form-item prop="workUnit">
              <el-input
                v-model="ndividualObj.workUnit"
                placeholder="请输入工作单位"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">职位</div>
          <div class="vip-input">
            <el-form-item prop="job">
              <el-input
                v-model="ndividualObj.job"
                placeholder="请输入职位"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">技术职称</div>
          <div class="vip-input">
            <el-form-item prop="technicalTitle">
              <el-input
                v-model="ndividualObj.technicalTitle"
                placeholder="请输入技术职称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">愿意被推荐加入专业委员会</div>
          <div class="vip-input">
            <el-form-item prop="isWilling">
              <!-- <el-input
                v-model="ndividualObj.isWilling"
                placeholder="请输入手机号码"
              ></el-input>-->
              <el-select v-model="ndividualObj.isWilling">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="vip-name">快递地址</div>
          <div class="vip-input">
            <el-form-item prop="address">
              <el-input
                v-model="ndividualObj.address"
                placeholder="请输入快递地址"
              ></el-input>
            </el-form-item>
          </div>
          <!-- <div class="vip-name">个人免冠照</div>
          <div
            class="vip-inputUpLoad"
            v-if="!ndividualObj.mediaId"
            @click="upLoadImg"
          >
            <i class="el-icon-plus"></i>
          </div>
          <div
            class="vip-inputImg"
            v-if="ndividualObj.mediaId"
            @click="upLoadImg"
          >
            <img :src="wxImg" />
          </div> -->
        </el-form>
        <div class="vipChecked">
          <el-checkbox v-model="checked"></el-checkbox>
          <span @click="showBox">《入会须知》</span>
        </div>
        <div class="button" @click="payVip">下一步</div>
      </div>
      <div class="vip" v-if="typeItem === 3">
        <div class="demo-ruleForm">
          <div class="vip-name">
            会员昵称：
            <span>{{ ndividualObj.username }}</span>
          </div>
          <!-- <div class="vip-input">
           
          </div>-->
          <div class="vip-name">
            真实姓名：
            <span>{{ ndividualObj.name }}</span>
          </div>
          <div class="vip-input"></div>
          <div class="vip-name">
            手机号码：
            <span>{{ ndividualObj.mobile }}</span>
          </div>
          <div class="vip-input"></div>
          <div class="vip-name">
            性别：
            <span v-if="ndividualObj.sex === '1'">男</span>
            <span v-if="ndividualObj.sex === '2'">女</span>
          </div>
          <div class="vip-input"></div>
          <div class="vip-name">
            民族：
            <span>{{ ndividualObj.nation }}</span>
          </div>
          <!-- <div class="vip-name">
            出生年月：
            <span>{{ ndividualObj.birth }}</span>
          </div> -->
          <div class="vip-name">
            身份证：
            <span>{{ ndividualObj.idcard }}</span>
          </div>
          <div class="vip-name">
            邮箱：
            <span>{{ ndividualObj.email }}</span>
          </div>
          <div class="vip-name">
            专业：
            <span>{{ ndividualObj.major }}</span>
          </div>
          <div class="vip-name">
            学历：
            <span>{{ ndividualObj.education }}</span>
          </div>
          <div class="vip-name">
            工作单位：
            <span>{{ ndividualObj.workUnit }}</span>
          </div>
          <div class="vip-name">
            职位：
            <span>{{ ndividualObj.job }}</span>
          </div>
          <div class="vip-name">
            技术职称：
            <span>{{ ndividualObj.technicalTitle }}</span>
          </div>
          <div class="vip-name">
            愿意被推荐加入专业委员会：
            <span v-if="ndividualObj.isWilling === '1'">是</span>
            <span v-if="ndividualObj.isWilling === '2'">否</span>
          </div>
          <div class="vip-name">
            快递地址：
            <span>{{ ndividualObj.address }}</span>
          </div>
          <!-- <div class="vip-name">个人免冠照</div>
          <div class="vip-inputImg">
            <img :src="wxImg" />
          </div> -->
        </div>
        <div class="button" @click="goBack">上一步</div>
        <div class="button" @click="applyForMember">立即60元开通年会</div>
      </div>
      <div class="vip" v-if="typeItem === 2">
        <el-form
          :model="unitObj"
          ref="unitObjForm"
          label-width="0px"
          class="demo-ruleForm"
          :rules="unitRules"
        >
          <div class="vip-title">会员资料填写</div>
          <div class="vip-name">会员单位名称</div>
          <div class="vip-input">
            <el-form-item prop="companyName">
              <el-input
                v-model="unitObj.companyName"
                placeholder="请输入会员单位名称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">联系人姓名</div>
          <div class="vip-input">
            <el-form-item prop="name">
              <el-input
                v-model="unitObj.name"
                placeholder="请输入联系人姓名"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">联系电话</div>
          <div class="vip-input">
            <el-form-item prop="mobile">
              <el-input
                v-model="unitObj.mobile"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="button" @click="applyFor">立即申请</div>
      </div>
    </div>
    <vipBox v-if="showBoxType" @closer="closer"></vipBox>
  </div>
</template>

<script>
import wdBg from "@/assets/img/h5/wdBg.png";
import vipBox from "./vipBox";

import {
  applyForCompanyMember,
  applyForMember,
  memberLogin,
  // uploadHead,
  getParam
} from "@/api/api.js";

export default {
  components: {
    vipBox
  },
  data() {
    const checkAge = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const numRex = (rule, value, callback) => {
      // let myreg = /^[+]{0,1}(\d+)$/;
      if (value === "") {
        callback(new Error("联系人姓名不能为空"));
      } else {
        callback();
      }
    };
    const idRex = (rule, value, callback) => {
      let myreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback(new Error("请输入会员数量身份证ID"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的身份证ID"));
      } else {
        callback();
      }
    };
    const emailRex = (rule, value, callback) => {
      let myreg = /^([A-Za-z0-9_+-.])+@([A-Za-z0-9\-.])+\.([A-Za-z]{2,22})$/;
      if (value === "") {
        callback(new Error("请输入邮箱号码"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的邮箱号码"));
      } else {
        callback();
      }
    };
    //  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return {
      img: {
        wdBg
      },
      input: "",
      typeItem: 1,
      // wxImg: "",
      checked: true,
      // 个人
      ndividualObj: {
        userId: "",
        username: "",
        name: "",
        mobile: "",
        sex: "1", // 性别 1-男2-女,
        nation: "", //民族,
        // birth: "", //出生年月,
        idcard: "", //身份证,
        email: "", //邮箱,
        major: "", // 专业,
        education: "", //学历,
        job: "", //职位,
        technicalTitle: "", //技术职称,
        workUnit: "", //工作单位,
        isWilling: "1", //愿意被推荐加入的专业委员会 1-愿意 2-不愿意,
        address: "" //快递地址,
        // mediaId: "" // file类型 个人免冠照,
      },
      ndividualRules: {
        username: [{ required: true, message: "请输入会员昵称" }],
        name: [{ required: true, message: "请输入真实姓名" }],
        mobile: [{ validator: checkAge }],
        nation: [{ required: true, message: "请输入民族" }], //民族,
        // birth: [{ required: true, message: "请输入出生年月" }], //出生年月,
        idcard: [{ validator: idRex }], //身份证,
        email: [{ validator: emailRex }], //邮箱,
        major: [{ required: true, message: "请输入专业" }], // 专业,
        education: [{ required: true, message: "请输入学历" }], //学历,
        job: [{ required: true, message: "请输入职位" }], //职位,
        technicalTitle: [{ required: true, message: "请输入技术职称" }], //技术职称,
        workUnit: [{ required: true, message: "请输入工作单位" }], //工作单位,
        address: [{ required: true, message: "请输入快递地址" }] //快递地址,
      },
      // 单位
      unitObj: {
        userId: "",
        companyName: "",
        name: "",
        mobile: ""
      },
      unitRules: {
        companyName: [{ required: true, message: "公司名称" }],
        name: [{ validator: numRex }],
        mobile: [{ validator: checkAge }]
      },
      openID: "",
      userObj: {
        name: "",
        head: "",
        isExpire: 1,
        expirationDate: ""
      },
      showBoxType: false
    };
  },
  created() {
    const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
    this.openID = ListObj.openId;
    if (!ListObj.mobile) {
      this.$router.push({ name: "H5sign" });
    }
    this.unitObj.userId = ListObj.id;
    this.ndividualObj.userId = ListObj.id;
    this.ndividualObj.username = ListObj.name;
    this.userObj = {
      name: ListObj.name,
      head: ListObj.head,
      isExpire: ListObj.isExpire,
      expirationDate: ListObj.expirationDate
    };
    // this.userObj.isExpire = 1;
  },
  methods: {
    showBox() {
      this.showBoxType = true;
      // console.log('23')
    },
    closer() {
      this.showBoxType = false;
    },
    tabType(val) {
      this.typeItem = val;
    },
    payVip() {
      // if
      if (!this.checked) {
        this.$message({
          message: "请选择须知",
          type: "error"
        });
        return;
      }
      // if (!this.ndividualObj.mediaId) {
      //   this.$message({
      //     message: "请上传个人免冠照",
      //     type: "error"
      //   });
      //   return;
      // }
      this.$refs.ndividualObjForm.validate(valid => {
        if (valid) {
          const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
          this.openID = ListObj.openId;
          this.unitObj.userId = ListObj.id;
          this.ndividualObj.userId = ListObj.id;
          this.ndividualObj.username = ListObj.name;
          this.typeItem = 3;
          // this.applyForMember();
        } else {
          return false;
        }
      });
    },
    upLoadImg() {
      getParam(window.location.href.split("#")[0]).then(res => {
        if (res.code === 0) {
          const self = this;
          // eslint-disable-next-line no-undef
          wx.config({
            debug: false,
            appId: res.data.appid,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseImage", "uploadImage"]
          });
          // eslint-disable-next-line no-undef
          wx.ready(function() {
            // eslint-disable-next-line no-undef
            wx.chooseImage({
              count: 1, // 默认9
              sizeType: ["original", "compressed"],
              sourceType: ["album", "camera"],
              success: function(res) {
                self.wxImg = res.localIds[0].toString();
                // eslint-disable-next-line no-undef
                wx.uploadImage({
                  localId: self.wxImg,
                  isShowProgressTips: 1,
                  success: function(res) {
                    self.ndividualObj.mediaId = res.serverId;
                  }
                });
              }
            });
          });
        }
      });
    },
    goBack() {
      this.typeItem = 1;
    },
    memberLogin(id) {
      // const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
      memberLogin(id).then(res => {
        if (res.code === 0) {
          const obj = {
            openId: res.data.openId,
            expirationDate: res.data.expirationDate,
            head: res.data.head,
            id: res.data.id,
            isExpire: res.data.isExpire,
            mobile: res.data.mobile,
            name: res.data.name
          };
          this.userObj = {
            name: obj.name,
            head: obj.head,
            isExpire: obj.isExpire,
            expirationDate: obj.expirationDate
          };
          window.sessionStorage.setItem("userList", JSON.stringify(obj));
          // this.showTypa = true;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    applyFor() {
      this.$refs.unitObjForm.validate(valid => {
        if (valid) {
          const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
          this.openID = ListObj.openId;
          this.unitObj.userId = ListObj.id;
          this.ndividualObj.userId = ListObj.id;
          this.ndividualObj.username = ListObj.name;
          this.applyForCompanyMember();
        } else {
          return false;
        }
      });
    },
    applyForCompanyMember() {
      applyForCompanyMember(this.unitObj).then(res => {
        if (res.code === 0) {
          this.$message({
            message: "您已申请成功",
            type: "success"
          });
          this.$router.push({ name: "H5my" });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    applyForMember() {
      applyForMember(this.ndividualObj).then(res => {
        if (res.code === 0) {
          const that = this;
          // eslint-disable-next-line no-undef
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timeStamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseWXPay"]
          });
          // eslint-disable-next-line no-undef
          wx.ready(function() {
            // eslint-disable-next-line no-undef
            wx.chooseWXPay({
              appId: res.data.appId,
              timestamp: res.data.timeStamp,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              signType: res.data.signType,
              paySign: res.data.sign,
              success: function() {
                // eslint-disable-next-line to ignore the next line.
                window.open('http://www.shhhxh.com/hhxh/api/wechat/memberRegister');
                // const ListObj = JSON.parse(window.sessionStorage.getItem("userList"));
                // that.memberLogin(ListObj.openID);
                // that.$router.go(0);
              },
              cancel: function(res) {
                that.$message({
                  message: res.errMsg,
                  type: "error"
                });
              },
              fail: function(res) {
                that.$message({
                  message: res.errMsg,
                  type: "error"
                });
              }
            });
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.vipLink {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  .vipLink-banner {
    position: relative;
    margin-bottom: 30px;
    width: 100%;
    height: 126px;
    background-size: 100% 100%;
  }
  .vipLink-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 126px;
    padding: 16px;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 24px;
      margin: 10px 0;
    }
    .text {
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 14px;
    }
  }
  .el-select {
    width: 100%;
  }
  .loging {
    display: flex;
    align-items: center;
    .img {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background: #e7ecf0;
      overflow: hidden;
    }
    .name {
      margin-left: 20px;
      color: #fff;
      font-size: 16px;
      .time {
        margin-top: 6px;
        font-size: 12px;
        opacity: 0.5;
      }
    }
  }
  .vip-nav {
    display: flex;
    justify-content: space-around;
    span {
      height: 30px;
      font-size: 14px;
      color: #343434;
    }
    .act {
      color: #6c2c66;
      border-bottom: 2px solid #6c2c66;
    }
  }
  .vip {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    &-title {
      margin: 10px 0;
      font-size: 10px;
      color: #787f87;
    }
    &-name {
      margin-bottom: 10px;
      font-size: 14px;
      color: #141414;
    }
    &-inputUpLoad {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      border: 1px solid #ddd;
    }
    // &-input {
    //   padding-bottom: 10px;
    //   margin-bottom: 10px;
    // }
    .vipChecked {
      margin: 20px auto 0;
      font-size: 14px;
      color: #141414;
    }
    .button {
      margin: 30px auto 0;
      width: 320px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #6c2c66;
      border-radius: 4px;
      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
